export default __webpack_public_path__ + "static/media/image-glass-and-keyboard.dd62168e.jpg";